import type { EditorView } from 'prosemirror-view';

/**
 * Тип описывает "paste"-обработчик. Он возвращает true, если событие
 * "забрано" (handle), и false — если нужно передать дальше.
 */
export type PasteHandler = (view: EditorView, event: ClipboardEvent) => boolean;

/**
 * Возвращает единый paste-обработчик, который пробует handlers по очереди.
 * Как только один вернул true, остальные не вызываются.
 */
export function handleCombinePaste(handlers: PasteHandler[]): PasteHandler {
  return (view, event) => {
    for (const handler of handlers) {
      const used = handler(view, event);
      if (used) {
        return true; // Останавливаем цепочку
      }
    }
    // Если никто не обработал — false
    return false;
  };
}
